// extracted by mini-css-extract-plugin
export default {"spinnerDual":"Spinner_spinnerDual__i1AAl","spin":"Spinner_spin__Q9zsz","loader":"Spinner_loader__GQ3jW"};